import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MapMarkerGreyFilled() {
    return (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 18" }, { children: [_jsx("path", { d: "M15.6316,6.6316C15.6316,10.2941,9,18,9,18S2.3684,10.2941,2.3684,6.6316a6.6316,6.6316,0,0,1,13.2632,0Z", fill: "#9b9b9b" }, void 0),
            _jsx("circle", { cx: "9", cy: "6.6316", r: "3.5009", fill: "#d1d1d1" }, void 0)] }), void 0));
}
//# sourceMappingURL=MapMarkerGreyFilled.js.map